import React from 'react';
import { Link } from 'react-router-dom';
const SampleRef = () => {
    return ( 
        <section className='bg-dark-blue'>
            <div className='container py-5'>
<div className='row'>
<div className="col-lg-6 text-white">
    <h2 className='mb-4'>لورم اپیسوم</h2>
    <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزا</p>
    <p className='text-white h5'>برای مشاهده نمونه کار ها کلیک کنید</p>
</div>
<div className="col-lg-6">
    <div className="row text-center h-100">
        <div className="col-lg-12">
    <img src="images/pointing.png" alt="" className='img-fluid'/>
        </div>
        <div className="col-lg-12">
<Link to='/Products/Index' type="button" className="btn btn-outline-light"> مشاهده... </Link>

        </div>
    </div>
</div>
</div>
            </div>
        </section>
     );
}
 
export default SampleRef;
